import { EndingField, Field, FormFieldType, RatingField, TextArea } from 'scripts/type'

export default function fieldGroupByType(fields: Field[]) {
  const [ratingField] = fields.filter((field) => field.type === FormFieldType.RatingField)
  const [textareaField] = fields.filter((field) => field.type === FormFieldType.TextArea)
  const [endingField] = fields.filter((field) => field.type === FormFieldType.EndingField)
  return {
    ratingField: ratingField as RatingField,
    textareaField: textareaField as TextArea,
    endingField: endingField as EndingField,
  }
}
